import * as dataRequestService from "../shared/svc-data-request";
//import * as dataRequestService from "../shared/data-request-service"
import * as $ from "jquery";
import { UserDetails } from "../shared/user-details";

const dataService = dataRequestService.GetDataRequestService();

// Commented out code versions of the methods using the updated data request service
// which is not dependent on jQuery, handles async better and performs better

export function enableSqlTracing(enable: boolean): JQueryPromise<any> {
    const defer = $.Deferred();
    var data = {
        enable
    };
    dataService.SendJsonRequestWithData("POST",
        "/api/Security/EnableSqlTracing",
        data,
        (result) => { defer.resolve(result) },
        () => { defer.resolve(false) },
        true
    );
    return defer.promise();
}
//export async function enableSqlTracing(enable: boolean): Promise<any> {
//    try {
//        return await dataService.SendJsonRequestWithData(
//            "POST",
//            "/api/Security/EnableSqlTracing",
//            { enable }
//        );
//    } catch {
//        return false;
//    }
//}

export function getSqlDataTrace(): JQueryPromise<any> {
    const defer = $.Deferred();
    dataService.SendJsonRequestWithData("GET",
        "/api/Security/GetSqlTraceData",
        null,
        (result) => { defer.resolve(result) },
        () => { defer.resolve(false) },
        true
    );
    return defer.promise();
}
//export async function getSqlDataTrace(): Promise<any> {
//    try {
//        return await dataService.SendJsonRequest(
//            "GET",
//            "/api/Security/GetSqlTraceData"
//        );
//    }
//    catch {
//        return false;
//    }
//}

export function clearSqlDataTrace(): JQueryPromise<any> {
    const defer = $.Deferred();
    dataService.SendJsonRequestWithData("POST",
        "/api/Security/ClearSqlTraceData",
        null,
        (result) => { defer.resolve(result) },
        () => { defer.resolve(false) },
        true
    );
    return defer.promise();
}
//export async function clearSqlDataTrace(): Promise<any> {
//    try {
//        return await dataService.SendJsonRequest(
//            "POST",
//            "/api/Security/ClearSqlTraceData"
//        );
//    }
//    catch {
//        return false;
//    }
//}

export function getMenu(): JQueryPromise<any> {
    const defer = $.Deferred();
    dataService.SendJsonRequestWithData("GET",
        "/api/Menu/GetMenu",
        null,
        (result) => { defer.resolve(result) },
        () => { defer.resolve(false) },
        true
    );
    return defer.promise();
}
//export async function getMenu(): Promise<any> {
//    try {
//        return await dataService.SendJsonRequest(
//            "GET",
//            "/api/Menu/GetMenu"
//        );
//    }
//    catch {
//        return false;
//    }
//}

export function getUsersToImpersonate(userLastAndFirstName: string): JQueryPromise<any> {
    const defer = $.Deferred();
    var data = {
        userLastAndFirstName: userLastAndFirstName,
        rowCount: 10
    };
    dataService.SendJsonRequestWithData("GET",
        "/api/Security/SearchForUsersToImpersonate",
        data,
        (result) => { defer.resolve(result) },
        () => { defer.resolve(false) },
        true
    );
    return defer.promise();
}
//export async function getUsersToImpersonate(userLastAndFirstName: string): Promise<any> {
//    try {
//        return await dataService.SendJsonRequestWithData(
//            "GET",
//            "/api/Security/SearchForUsersToImpersonate",
//            { userLastAndFirstName, rowCount: 10 }
//        );
//    } catch {
//        return false;
//    }
//}

export function impersonate(userIdToImpersonate: number, displayNameToImpersonate: string): JQueryPromise<any> {
    const defer = $.Deferred();
    var data = {
        userIdToImpersonate: userIdToImpersonate,
        displayNameToImpersonate: displayNameToImpersonate
    };
    dataService.SendJsonRequestWithData("POST",
        "/api/Login/ImpersonateUser",
        data,
        (result) => { defer.resolve(result) },
        () => { defer.resolve(false) },
        true
    );
    return defer.promise();
}
//export async function impersonate(userIdToImpersonate: number, displayNameToImpersonate: string): Promise<any> {
//    try {
//        return await dataService.SendJsonRequestWithData(
//            "POST",
//            "/api/Login/ImpersonateUser",
//            { userIdToImpersonate, displayNameToImpersonate }
//        );
//    } catch {
//        return false;
//    }
//}

export function stopImpersonating(): JQueryPromise<any> {
    const defer = $.Deferred();

    dataService.SendJsonRequest("POST",
        "/api/Login/StopImpersonating",
        (result) => { defer.resolve(result) },
        () => { defer.resolve(false) },
    );

    return defer.promise();
}
//export async function stopImpersonating(): Promise<any> {
//    try {
//        return await dataService.SendJsonRequest(
//            "POST",
//            "/api/Login/StopImpersonating"
//        );
//    }
//    catch {
//        return false;
//    }
//}

export function getUserDetails(): JQueryPromise<UserDetails> {
    const defer = $.Deferred();
    var data = {};
    dataService.SendJsonRequestWithData("GET",
        "/api/Menu/GetUserDetails",
        data,
        (result) => { defer.resolve(result) },
        () => { defer.resolve(false) },
        true
    );
    return defer.promise();
}
//export async function getUserDetails(): Promise<UserDetails> {
//    try {
//        return await dataService.SendJsonRequest<UserDetails>(
//            "GET",
//            "/api/Menu/GetUserDetails"
//        );
//    }
//    catch(error) {
//        console.error('');
//    }
//}
